import React from 'react'
import { getFormattedDate } from 'astra-core/utils/date/getFormattedDate'

import { useDateToString } from 'hooks/useDateToString'

import * as S from './DateHeader.styled'

export const DateHeader = ({
  date,
  view
}: {
  date: string
  view?: 'calendar' | 'live' | 'line'
}) => {
  const { checkDate } = useDateToString()
  let boldText = ''
  const dateText = `${checkDate(date)}${getFormattedDate({
    date,
    format: 'DD MMMM'
  })}`
  if (view === 'calendar') {
    boldText = getFormattedDate({ date, format: 'HH:00' })
  }
  return (
    <S.EventDate>
      {boldText && <S.EventDateBold>{boldText}</S.EventDateBold>}
      <S.EventDateText>{dateText}</S.EventDateText>
    </S.EventDate>
  )
}
